import { __assign } from 'tslib';
import PropTypes from 'prop-types';
import { propTypes as propTypes$1, defaultProps as defaultProps$1 } from '../LoadingIndicator/LoadingIndicator.types.js';

var propTypes = __assign(__assign({}, propTypes$1), { spinnerClassName: PropTypes.string, hasBackgroundBlur: PropTypes.bool });
var defaultProps = __assign(__assign({}, defaultProps$1), { hasBackgroundBlur: false, greyAnimation: true });

export { defaultProps, propTypes };
